module.exports = __webpack_public_path__ + "static/img/icon_zgw.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_zgw.png
// module id = Xhji
// module chunks = 18